<script setup>
import {ref} from "vue";
import localise from "../lang/localize.json";
import SearchDatabase from "./forms/SearchDatabase.vue";
import PositionMaker from "./forms/PositionMaker.vue";
// import {validateArray} from "./main"

const props = defineProps({
  lang: {
    type: String,
    default: 'de'
  }
})

const searchterm = ref('')
const formsent = ref(false)
const showNotification = ref(false)
const searchButtonText = ref(localise.btn_text_search_in_database[props.lang])
const prodListItems = ref([])
const posListItems = ref([])
const fullname = ref('');
const emailaddress = ref('');
const datenschutz = ref(true);
const mailcopy = ref(false);
const subject = ref(localise.input_default_val_find_in_database[props.lang]);
const about = ref('');
const senddata = ref(false)
const buttontext = ref(localise.btn_text_send_inquiry[props.lang])
const setpospos = ref(5)
const setposqty = ref(1)

const setpostext = ref('')
const showHint = ref(false)

const formIsValidated = ref(false)
const serachProduct = () => {
  if (searchterm.value === '') return
  searchButtonText.value = localise.btn_text_searching_in_database[props.lang];
  prodListItems.value = [];
  fetch(
      'https://portal.thermo-control.com/API/v2/searchProduct.php',
      {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          api_key: 'KAyAcRJZUacAYGRCeCfZXRAAAIQgAAEIACBxAggThJDyY0gAAEIQAACEIAABCAAgXoIIE7q',
          searchterm: searchterm.value,
        })
      }
  ).then(response => response.json())
      .then(data => {
        if (data.status) {
          addProductData(data.products)
        }
        setTimeout(() => {
          formsent.value = false;
          searchButtonText.value = localise.btn_text_newsearch_in_database[props.lang];
        }, 3000)
      })

}

const addProductData = (dataListItems) => {

  for (let item of dataListItems) {
    prodListItems.value.push(
        {
          productid: item.productid,
          specification: item.specification,
          headertext: item.headertext,
          serialnumber: item.serialnumber,
          meta: {
            shopParent: item.meta.shopParent,
            shopVarante: item.meta.shopVariant,
            teid: item.meta.teid
          }
        }
    );
  }

  validate()

}

const addProductToList = (id) => {

  setpostext.value = prodListItems.value[id].productid + '/' + prodListItems.value[id].specification

  if (prodListItems.value[id].serialnumber) setpostext.value = setpostext.value + localise.msg_according_sn[props.lang] + prodListItems.value[id].serialnumber


}

const addPos = () => {

  posListItems.value.push({
    pos: setpospos.value,
    qty: setposqty.value,
    postext: setpostext.value
  })

  setposqty.value = 1;
  setpostext.value = '';
  setpospos.value = setpospos.value * 1 + 5;

  validate()

}

const removePositem = (pos) => {

  const index = posListItems.value.findIndex((i) => {
    return i.pos === pos;
  })

  posListItems.value.splice(index, 1);

  if (posListItems.value.length === 0) setpospos.value = 5;

  validate()
}


const validate = () => {

  formIsValidated.value = (mailcopy.value)
      ? datenschutz.value && posListItems.value.length > 0 && fullname.value.length > 0 && emailaddress.value.length > 0
      : datenschutz.value && posListItems.value.length > 0 && fullname.value.length > 0

}

const submit = async () => {
  formsent.value = true;
  senddata.value = true;
  buttontext.value = localise.btn_text_sending_inquiry[props.lang]

  if (!formIsValidated.value) {
    showHint.value = true
    return false
  }

  fetch(
      'https://api.thermo-control.com/v1/send-contact-mail',
      {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          api_key: 'KAyAcRJZUacAYGRCeCfZXRAAAIQgAAEIACBxAggThJDyY0gAAEIQAACEIAABCAAgXoIIE7q',
          fullname: fullname.value,
          emailaddress: emailaddress.value,
          subject: subject.value,
          about: about.value,
          lang: props.lang,
          datenschutz: datenschutz.value,
          mailcopy: mailcopy.value,
          positions: posListItems.value,
          sender: 'thermo',
        })
      }
  ).then(response => response.json())
      .then(data => {
        showNotification.value = true
        senddata.value = false;
        formsent.value = data.formsent;
        buttontext.value = (data.formsent) ? localise.btn_text_message_success[props.lang] : localise.btn_text_send_message[props.lang];
        setTimeout(() => {
          formsent.value = false;
          buttontext.value = localise.btn_text_resend_inquiry[props.lang];
        }, 3000)
      })


  /*   const messages = JSON.parse(localStorage.getItem("messages"));
     const { name, phonenumber} = this;
     messages.push({
       name,
       phonenumber,
     });
     localStorage.setItem("messages", JSON.stringify(messages));*/
}

const makePosition = (newPosition) => {
  posListItems.value.push(newPosition)
}

</script>

<template>
  <form @submit.prevent="submit" class="space-y-8">

    <!--  Search in wawireg API database  -->
    <search-database :lang="lang"
                     :header="localise.dbsearch_header[lang]"
                     @setnewpostext="(newText) => setpostext = newText"
    ></search-database>

    <!--  Slot for custom product configurators  -->

    <slot :onSetNewPostext="(newText) => setpostext = newText"></slot>



    <!--  Position table -->
    <position-maker :lang="lang"
                    :header="localise.posmaker_header[lang]"
                    :subheader="localise.posmaker_subheader[lang]"
                    @makeposition="makePosition"
                    :newpostext="setpostext"
    ></position-maker>

    <!--  Contact data section -->
    <section class="grid grid-cols-6 gap-6">
      <hr class="col-span-6 my-0">
      <header class="col-span-6">
        <h3 class="text-lg ">{{ localise.section_header_contact[lang] }}</h3>
      </header>
      <section class="col-span-6 lg:col-span-3">
        <label class="block text-sm font-medium"
               for="fullname"
        >{{ localise.input_label_fullname[lang] }}
          <span class="text-red-700 text-xs">*</span>
        </label>
        <input v-model="fullname"
               autocomplete="family-name"
               class="w-full input-md"
               required
               type="text"
               @input="validate"
               id="fullname"
        >
      </section>

      <div class="col-span-6 lg:col-span-3">
        <label class="block text-sm font-medium"
               for="emailaddress"
        >{{ localise.input_label_email[lang] }}
          <span v-show="mailcopy"
                class="text-red-700 text-xs"
          >*</span>
        </label>
        <input v-model="emailaddress"
               autocomplete="email"
               type="text"
               :required="mailcopy"
               class="w-full input-md"
               @input="validate"
               id="emailaddress"
        >
      </div>

      <div class="col-span-6">
        <label for="subject"
               class="block text-sm font-medium"
        >{{ localise.input_label_subject[lang] }}
        </label>
        <input v-model="subject"
               type="text"
               autocomplete="subject"
               class="w-full input-md"
               id="subject"
        >
      </div>

      <div class="col-span-6">
        <label class="block text-sm font-medium"
               for="about"
        >{{ localise.textfield_label_message[lang] }}
        </label>
        <div class="mt-1">
            <textarea v-model="about"
                      rows="3"
                      class="mt-1 block w-full input-md"
                      id="about"
            />
        </div>
      </div>

      <div class="col-span-6">
        <div class="mt-4 space-y-4">
          <div class="flex items-start">
            <div class="flex h-5 items-center">
              <input v-model="datenschutz"
                     required
                     type="checkbox"
                     class="h-4 w-4 rounded border-slate-300 text-red-600 focus:ring-red-500 checked:bg-red-700"
                     @change="validate"
                     id="datenschutz"
              >
            </div>
            <div class="ml-3 text-sm cursor-pointer" @click="datenschutz = !datenschutz">
              <label for="datenschutz"
                     class="font-medium"
              >{{ localise.checkbox_label_privacy[lang] }}
                <span class="text-red-700 text-xs">*</span>
              </label>
              <br>
              <span class="text-slate-500 text-xs">{{ localise.checkbox_text_privacy[lang] }}<a :href="localise.checkbox_link_privacy[lang]">{{ localise.checkbox_link_privacy_label[lang] }}</a>.</span>
            </div>
          </div>
          <div>
            <div class="flex items-start">
              <div class="flex h-5 items-center">
                <input v-model="mailcopy"
                       type="checkbox"
                       class="h-4 w-4 rounded border-slate-300 text-red-600 focus:ring-red-500"
                       @change="validate"
                       id="mailcopy"
                >
              </div>
              <div class="ml-3 text-sm cursor-pointer" @click="mailcopy = !mailcopy">
                <label for="mailcopy"
                       class="font-medium"
                >{{ localise.checkbox_label_send_email_copy[lang] }}
                </label>
                <br>
                <span class="text-slate-500 text-xs">{{ localise.checkbox_text_send_email_copy[lang] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--  Submit button section -->
    <div class="grid grid-cols-6 gap-6">

      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <button type="submit"
                class=" group relative flex w-full justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                :disabled="!formIsValidated"
                :class="{'bg-green-600 hover:bg-green-600 focus:ring-green-500' : formsent,'bg-green-400 hover:bg-green-400 focus:ring-green-500' : senddata, 'bg-slate-500 border-2 border-slate-800 hover:bg-slate-500 cursor-not-allowed focus:ring-slate-500': !formIsValidated}"
        >
          {{ buttontext }}
        </button>
        <Transition>
          <aside class="fixed right-10 bottom-4 z-50 rounded-md bg-yellow-300 px-4 py-2 text-slate-800 transition hover:bg-yellow-600"
                 v-show="showHint"
          >
            {{ localise.msg_empty_product_list[lang] }}
          </aside>
        </Transition>
      </div>

      <transition name="fade">
        <aside class="col-span-6 lg:col-span-4"
               v-if="showNotification"
        >
          <div class="pointer-events-auto w-full max-w-5xl overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div class="p-4">
              <div class="flex items-start">
                <div class="flex-shrink-0">
                  <svg class="h-6 w-6 text-green-400"
                       fill="none"
                       viewBox="0 0 24 24"
                       stroke-width="1.5"
                       stroke="currentColor"
                       aria-hidden="true"
                  >
                    <path stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div class="ml-3 w-0 flex-1 pt-0.5">
                  <p class="text-sm font-medium text-slate-900">{{ localise.msg_notification_success_header[lang] }}</p>
                  <p class="mt-1 text-sm text-slate-500">{{ localise.msg_notification_success_text[lang] }}</p>
                </div>
                <div class="ml-4 flex flex-shrink-0">
                  <button type="button"
                          class="inline-flex rounded-md bg-white text-slate-400 hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                          @click="showNotification = !showNotification"
                  >
                    <span class="sr-only">Close</span>
                    <svg class="h-5 w-5"
                         viewBox="0 0 20 20"
                         fill="currentColor"
                         aria-hidden="true"
                    >
                      <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </transition>

    </div>

  </form>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>